import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import 'element-plus/es/components/loading/style/css';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';

export default function (app) {
  // app.use(ElementPlus);
  Object.entries(ElementPlusIconsVue).forEach(([key, component]) => {
    app.component(key, component);
  });
}
